import { ScrollSpy } from 'bootstrap';
import helpers from './helpers.js';

const globalNav = document.querySelector(".global-nav");
let globalNavOriginalOffset;
const stickyNav = document.querySelector(".sticky-nav");
const jsAnchorNav = document.querySelector(".js-anchor-nav");
const navbarBrand = document.getElementById("navbarBrand");
let stickyNavOriginalOffset;

var general = {
    init: function () {
        var globalAlert = document.getElementById("globalAlert");
        if (globalAlert) {
            document.documentElement.style.setProperty('--global-nav-top', globalAlert.offsetHeight);
            globalAlert.addEventListener('closed.bs.alert', function () {
                document.documentElement.style.setProperty('--global-nav-top', 0);
            });
        }

        if (jsAnchorNav) {
            let scrollSpy = new ScrollSpy(document.body, {
                target: '.js-anchor-nav'
            })
        }

        const downCarets = document.querySelectorAll(".js-down-caret");
        if (downCarets)
            downCarets.forEach(el => el.addEventListener("click", this.scrollToNextSection));

        let last_scroll_top = 0;

        document.addEventListener(
            'scroll',
            (event) => {
                // TODO: Find a better way than this to avoid miscalculation of sticky nav position
                this.setNavOffsets();
                if (navbarBrand)
                    navbarBrand.style.transition = "transform .4s ease-in-out";
                // handle scroll event
                let scroll_top = window.scrollY;
                if (stickyNav) {
                    if (scroll_top <= stickyNavOriginalOffset)
                        document.body.classList.remove("sticky-stuck");
                    else
                        document.body.classList.add("sticky-stuck");
                }
                // iphones bounce when scrolling to top, hence the first check to ensure displaying nav when at top of page
                if (scroll_top <= globalNavOriginalOffset) {
                    document.body.classList.remove("scrolled-up");
                    document.body.classList.remove('scrolled-down');
                } else if (scroll_top < last_scroll_top) {
                    document.body.classList.add('scrolled-up');
                } else {
                    document.body.classList.remove('scrolled-up');
                    document.body.classList.add('scrolled-down');
                }
                last_scroll_top = scroll_top;
            },
            { passive: true }
        );

  

        window.addEventListener('resize', helpers.debounce(function () { general.setNavOffsets() }, 200));

        window.addEventListener('CookiebotOnAccept', initCookiebot);

        function initCookiebot(){
            console.log("initCookiebot");
            if (!Cookiebot.consent.marketing || !Cookiebot.consent.statistics) {
                var videoPlayer = document.querySelectorAll('.js-player-consent');
                videoPlayer.forEach(function (x) {
                    var iframe = x.querySelector("iframe");
                    var cookieConsent = iframe.dataset.cookieconsent;
                    if (cookieConsent?.includes('marketing') && cookieConsent?.includes('statistics')) {
                        x.classList.add("d-none");
                        var text = x.closest(".js-video-wrapper").querySelector(".js-player-consent-text-marketing-statistics");
                        if (text) {
                            text.classList.remove("d-none");
                        }
                    }
                    else if (cookieConsent?.includes('marketing')) {
                        var text = x.closest(".js-video-wrapper").querySelector(".js-player-consent-text-marketing");
                        if (text) {
                            text.classList.remove("d-none");
                        }
                    }
                    else if (cookieConsent?.includes('statistics')) {
                        var text = x.closest(".js-video-wrapper").querySelector(".js-player-consent-text-statistics");
                        if (text) {
                            text.classList.remove("d-none");
                        }
                    }
                });
                window.addEventListener('CookiebotOnAccept', setConsent);
            }
        }

        function setConsent() {
            if (Cookiebot.consent.marketing && Cookiebot.consent.statistics) {
                let consentTexts = document.querySelectorAll('[class*=" js-player-consent-text"],[class^="js-player-consent-text"]');
                consentTexts.forEach(x => x.classList.add("d-none"));
                const videoPlayers = document.querySelectorAll('.js-player-consent');
                videoPlayers.forEach(function (player) {
                    player.classList.remove("d-none");
                    let iframe = player.querySelector("iframe");
                    iframe.removeAttribute("style");
                    iframe.contentWindow.location.reload();
                });
            }
        }


        // Hijacking anchorlinks for smooth scrolling on iOS
        document.querySelectorAll('a[href^="#"]:not(.CybotCookiebotDialogBodyButton)').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();
                document.querySelector(this.getAttribute('href')).scrollIntoView({
                    behavior: 'smooth'
                });
            });
        });

    },
    scrollToNextSection: function () {
        document.querySelector("main section:not(.travel-info-banner)").scrollIntoView({ behavior: 'smooth' });
    },
    setNavOffsets: function () {
        if (globalNav) {
            globalNavOriginalOffset = globalNav.previousElementSibling.offsetTop + globalNav.previousElementSibling.offsetHeight;

            if (globalNav.offsetTop > globalNavOriginalOffset)
                document.body.classList.add("scrolled-up");

            if (stickyNav) {
                stickyNavOriginalOffset = stickyNav.previousElementSibling.offsetTop + stickyNav.previousElementSibling.offsetHeight;

                if (stickyNav.offsetTop > stickyNavOriginalOffset)
                    document.body.classList.add("sticky-stuck");
            }
        }
    },
}

export default general;